import { createAsyncThunk } from '@reduxjs/toolkit';
import type { DatadogEmbedUrlResponse } from '../../types/plataforma';
import { plataformaEmbedUrlService } from './services';

export const fetchPlataformaEmbedUrl = createAsyncThunk<
  DatadogEmbedUrlResponse,
  void,
  { rejectValue: string }
>('plataformaEmbedUrl/fetch', async (_, { rejectWithValue }) => {
  try {
    return await plataformaEmbedUrlService.getEmbedUrl();
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : 'Erro ao carregar URL de embed do dashboard',
    );
  }
});
